import { GraphForm } from "./graph_form";
import { Keyword } from "./keyword";
import { ConditionPanel } from "./condition_panel";
import { TargetDate } from "./target_date";
import { StatsGraph } from "./stats_graph";
import $ from "jquery";
import { SeriesSet } from "../model/series";

class CookStatsGraphForm extends GraphForm {
  private keyword: Keyword;
  private conditionPanel: ConditionPanel;
  private targetDate: TargetDate;
  private graph!: StatsGraph;

  private static readonly COLORS = ["#B8C12B", "#1F91CF"];
  private static readonly YEARLY_COLORS = ["#1F91CF"];

  constructor() {
    super();
    this.keyword = new Keyword($("#keyword"));
    this.conditionPanel = new ConditionPanel($("#cook_trends_form"));
    this.targetDate = this.conditionPanel.targetDate;
  }

  protected canvasElement(): JQuery {
    return $("#si_graph");
  }

  private partition(): string {
    return $("#partition").val() as string;
  }

  initialize(_invalidDataCombinations?: any): void {
    this.keyword.initialize();
    this.conditionPanel.initialize([]);
    this.graph = this.initializeGraph();
  }

  keywordValue(): string {
    return this.keyword.value();
  }

  isYearly(): boolean {
    return this.partition() === "yearly";
  }

  private initializeGraph(): StatsGraph {
    return new StatsGraph(this.canvasElement(), {
      xAxis: StatsGraph.AxisPolicy.forPartition(this.partition()),
      yAxis: StatsGraph.FloatAxis,
      legend: this.isYearly()
        ? (StatsGraph as any).TextLegend
        : (StatsGraph as any).WrappedSeriesLegend,
      colors: this.isYearly()
        ? CookStatsGraphForm.YEARLY_COLORS
        : CookStatsGraphForm.COLORS,
      todayLine: !this.isYearly(),
    });
  }

  showKeywordNotFoundError(keyword: string): void {
    this.graph.drawMessage(`
      「${keyword}」は見付かりませんでした。
      別の単語をお試しください。
    `);
  }

  showHttpError(res: { status: number }): void {
    this.graph.drawErrorMessage(`
      申し訳ありません、通信エラーが発生しました。
      少し時間をおいて再度お試しください。
      ステータス: ${res.status}, ${new Date()}
    `);
  }

  showNoDataMessage(): void {
    this.graph.drawMessage(`
      この条件ではデータが存在しません。
      期間や集計単位を変更してお試しください。
    `);
  }

  // Graph rendering
  renderGraph(seriesSet: SeriesSet): void {
    this.graph.addSeriesSet(seriesSet);
    this.graph.drawAll();
    this.enableCsvButton($(".si_graph_box .csv_button"));
  }
}

export { CookStatsGraphForm };
